import React, { ReactNode } from 'react'

import { Dropdown as AntDropdown } from 'antd'

interface DropdownProps {
  size?: 'default' | 'small'
  title?: string | ReactNode
  children: ReactNode
  extra?: string | ReactNode
  className?: string
  actions?: React.ReactNode[]
  style?: React.CSSProperties
  overlay: JSX.Element
  trigger?: ('click' | 'hover' | 'contextMenu')[]
  placement?: 'bottomLeft' | 'bottomCenter' | 'bottomRight' | 'topLeft' | 'topCenter' | 'topRight'
  disabled?: boolean
  open?: boolean
  onOpenChange?: (visible: boolean) => void
}

const Dropdown = (props: DropdownProps) => {
  return <AntDropdown {...props}>{props.children}</AntDropdown>
}

export default Dropdown
